import GetInfoService from "../services/GetInfoService";
import { SET_VISITABILITIES } from "./actionTypes";
import { setAlertMessage } from "./messageAlertAction";
import MessageAlertModel from "../component/MessageAlertComponent/MessageAlertModel";


export const setVisitabilities = (visitabilities) => {
    return {type: SET_VISITABILITIES, visitabilities}
}


export const getVisitabilities = () => {
    const infoService = new GetInfoService();
    return (dispatch, getState) => {
        infoService.getVisitabilities(getState().language.code).then((visitabilities) => {
            dispatch(setVisitabilities(visitabilities));
        }).catch((error) => {
            dispatch(setAlertMessage([new MessageAlertModel({type: "error", title: "Error", message: error.message})]));
        });
    }
}